import { EditItem, IEditItem } from "ui/Scripts/source/models/common/editItem";
import { IModifyUser, ModifyUser } from "ui/Scripts/source/models/user/modifyUser";
import { ITaskPriorityListItem } from "./taskPriorityListItem";

export interface ITaskPriorityEditItem extends IEditItem {
    code: string;
    comment: string;
    sortOrder: number;
    activeState: number;
    modifyUser: IModifyUser;
}

export class TaskPriorityEditItem extends EditItem implements ITaskPriorityEditItem {
    code: string;
    comment: string;
    sortOrder: number;
    activeState: number;
    modifyUser: IModifyUser;

    constructor();
    constructor(obj: ITaskPriorityEditItem);
    constructor(obj?: ITaskPriorityListItem);
    constructor(obj?: any) {
        super(obj);
        this.code = obj && obj.code || "";
        this.comment = obj && obj.comment || "";
        this.sortOrder = obj && obj.sortOrder || 0;
        this.activeState = obj && obj.activeState || 0;
        this.modifyUser = new ModifyUser(obj ? obj.modifyUser : null);
    }
}

export type TTaskPriorityEditItemNewSave = {
    id: string;
    code: string;
    comment: string;
    sortOrder: number;
    activeState: number;
}